'use strict';

module.exports = require('./Radio');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._rc-radio@2.0.0@rc-radio/lib/index.js
 ** module id = 600
 ** module chunks = 0 1
 **/